export interface Message {
  id: string;
  role: 'user' | 'model';
  text: string;
  timestamp: Date;
  groundingUrls?: { title: string; uri: string }[];
}

export enum ChatStatus {
  IDLE = 'idle',
  SENDING = 'sending',
  ERROR = 'error'
}
